module.exports = __webpack_public_path__ + "static/media/calculator-1-thumbnail.037ccbb6.png";